import { createAsyncThunk } from "@reduxjs/toolkit";
import { offlineSearchSuggestion } from "../offlineSearchService/index.js";
import { searchApi } from "../../../api/searchApi.js";
import {
  setApiReachable,
  setApiUnreachable,
} from "../../networkStatus/networkStatusSlice.js";
import offlineOrTimeoutPromise from "../utils/offlineOrTimeoutPromise.js";

const returnPayload = (suggestionArray, online) => ({
  suggestions: suggestionArray,
  isOffline: !online,
});

export const drugSearchSuggestionsThunk = createAsyncThunk(
  'enhancedSearch/drugSearchSuggestions',
  async (arg, { dispatch }) => {
    const { searchText } = arg;
    try {
      const suggestionApiPromise = searchApi.drugSearchSuggestion(searchText);
      const suggestionArray = await Promise.race([
        suggestionApiPromise,
        offlineOrTimeoutPromise(),
      ]);
      dispatch(setApiReachable());
      return returnPayload(suggestionArray, true);
    } catch (error) {
      dispatch(setApiUnreachable());
      try {
        const offlineArray = await offlineSearchSuggestion(searchText);
        return returnPayload(offlineArray, false);
      } catch (offlineError) {
        console.error(
          "Offline search also failed for drug suggestions:",
          offlineError
        );
        return returnPayload([], false);
      }
    }
  }
);